import type { App } from 'vue'
import { onMounted, onUnmounted, Plugin, ref } from 'vue'
import router from '@/router/index'
import { ActionButtonI, ActionIconI } from '../typescript/types/ui-components/TableItem'

function BaseScript() {
  const breakpointWidth = ref(document.documentElement.offsetWidth)
  function handleResize() {
    return (breakpointWidth.value = document.documentElement.offsetWidth)
  }
  onMounted(() => window.addEventListener('resize', handleResize))
  onUnmounted(() => window.removeEventListener('resize', handleResize))

  function getIconUrl(name: string) {
    return new URL(`../assets/icons/${name}`, import.meta.url).href
  }
  function getFileUrl(name: string) {
    return new URL(`../assets/files/${name}`, import.meta.url).href
  }
  function goToRoute(link: string) {
    router.push(link)
  }
  async function goReissueRoute(id: number) {
    window.location.href =
      '/clientarea.php?action=productdetails&id=' + id + '&modop=custom&a=ClientAreaCustomReissueCertificate'
  }

  async function goToProductDetails(id: number) {
    const host = window.location.origin

    window.location.href = `${host}/clientarea.php?action=productdetails&id=${id}`
  }

  async function goToTicketsPage() {
    const host = window.location.origin

    window.location.href = `${host}/clientarea/my-tickets`
  }

  function getFontSize(weight: number, sizes: number[]): string | void {
    if (sizes.length === 5) {
      if (breakpointWidth.value >= 1904) {
        return `size${sizes[0]}-weight${weight}`
      } else if (breakpointWidth.value < 1904 && breakpointWidth.value >= 1264) {
        return `size${sizes[1]}-weight${weight}`
      } else if (breakpointWidth.value < 1264 && breakpointWidth.value >= 960) {
        return `size${sizes[2]}-weight${weight}`
      } else if (breakpointWidth.value < 960 && breakpointWidth.value >= 600) {
        return `size${sizes[3]}-weight${weight}`
      } else if (breakpointWidth.value < 600) {
        return `size${sizes[4]}-weight${weight}`
      }
    }
  }

  function getMargin(list: ActionButtonI[] | ActionIconI[], index: number) {
    if (list.length > 1 && list.length !== index) {
      return 'mr-2'
    }
  }

  return {
    breakpointWidth,
    getIconUrl,
    getFileUrl,
    getFontSize,
    goToRoute,
    goToTicketsPage,
    getMargin,
    goReissueRoute,
    goToProductDetails,
  }
}

export const baseScriptObject = BaseScript()

const initBaseScriptObject: Plugin<[]> = {
  install(app: App) {
    app.config.globalProperties.$baseScript = baseScriptObject
  },
}

export default initBaseScriptObject
